<template>
  <div class="course-details-modern">
    <!-- Modern Header with Glassmorphism -->
    <header class="modern-header" role="banner">
      <div class="header-content">
        <button class="back-btn" @click="goBack" aria-label="Go back">
          <i class="bi bi-arrow-left" aria-hidden="true"></i>
        </button>
        <div class="header-text text-dark">
          <h1 class="course-title">{{ course.name }}</h1>
          <p class="course-subtitle">Course Details</p>
        </div>
      </div>
    </header>

    <!-- Hero Section -->
    <section class="hero-section">
      <div class="course-image-container">
        <img :src="course.image || '/src/assets/img/category-1.png'" :alt="course.name || 'Course image'" class="course-hero-image" loading="lazy">
        <div class="image-overlay"></div>
      </div>
      <div class="course-info-card">
        <!--<div class="category-badge">{{ course?.cat_name }}</div>-->
        <h2 class="course-main-title">{{ course.name }}</h2>
        <div class="price-container">
          <span class="current-price">₹{{ course?.cost }}</span>
          <span class="price-suffix">/-</span>
        </div>
        <div class="course-stats">
          <div class="stat-item" v-if="course.lessons && course.lessons > 0">
            <i class="bi bi-play-circle-fill"></i>
            <span>{{ course.lessons }} Lessons</span>
          </div>
        </div>
      </div>
    </section>

    <main class="main-content" role="main">
      <!-- Course Description -->
      <section class="content-card" aria-labelledby="details-heading">
        <h3 id="details-heading" class="section-title">
          <i class="bi bi-info-circle"></i>
          About This Course
        </h3>
        <div class="course-description" v-html="course.description"></div>
      </section>

      <!-- Course Lessons -->
      <!--<section class="content-card" aria-labelledby="lessons-heading" v-if="lessons.length > 0">-->
      <!--  <h3 id="lessons-heading" class="section-title">-->
      <!--    <i class="bi bi-collection-play"></i>-->
      <!--    Course Content-->
      <!--  </h3>-->
      <!--  <div class="lessons-grid">-->
      <!--    <div class="lesson-card" v-for="(lesson, index) in lessons" :key="lesson.id" @click="() => selectLesson(lesson)"  >-->
      <!--      <div class="lesson-icon">-->
      <!--        <i class="bi bi-play-fill" v-if="lesson.full_payment==1 && user_details.balance!=0"></i>-->
      <!--        <i class="bi bi-lock-fill" v-else></i>-->
      <!--      </div>-->
      <!--      <div class="lesson-content">-->
      <!--        <h4 class="lesson-title">{{ lesson.name }}</h4>-->
      <!--        <div class="lesson-meta">-->
      <!--          <span class="lesson-duration">-->
      <!--            <i class="bi bi-clock"></i>-->
      <!--            {{ lesson.minutes }} min-->
      <!--          </span>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div class="lesson-status">-->
      <!--        <i class="bi bi-check-circle-fill" v-if="lesson.status === 'completed'"></i>-->
      <!--        <i class="bi bi-play-circle" v-else-if="lesson.status === 'in-progress'"></i>-->
      <!--      </div>-->
      <!--    </div>-->
      <!--  </div>-->
      <!--</section>-->
      
      
      <section class="content-card" aria-labelledby="lessons-heading" v-if="lessons.length > 0" style="margin-bottom: 7.5rem;">
          <h3 id="lessons-heading" class="section-title">
            <i class="bi bi-collection-play"></i>
            Course Content
          </h3>
        
          <!-- Tabs -->
          <div class="tabs">
            <button 
              v-for="tab in tabs" 
              :key="tab.key" 
              @click="activeTab = tab.key"
              :class="{ active: activeTab === tab.key }"
            >
              {{ tab.label }}
            </button>
          </div>
        
          <!-- Lessons Grid -->
          <div class="lessons-grid">
            <div 
              class="lesson-card"
              v-for="lesson in filteredLessons"
              :key="lesson.id"
              @click="() => selectLesson(lesson)"
            >
              <div class="lesson-icon">
                <i class="bi bi-play-fill" v-if="!lesson.notesPath && (lesson.full_payment==0 || (lesson.full_payment==1 && user_details.balance!=0))"></i>
                <i class="bi bi-book" v-else-if="lesson.notesPath && (lesson.full_payment==0 || (lesson.full_payment==1 && user_details.balance!=0))"></i>
                <i class="bi bi-lock-fill" v-else></i>
              </div>
        
              <div class="lesson-content">
                <h4 class="lesson-title">{{ lesson.name }}</h4>
                <div class="lesson-meta">
                  <span class="lesson-duration">
                    <i class="bi bi-clock"></i>
                    {{ lesson.minutes }} min
                  </span>
                </div>
                 <div class="lesson-tags" v-if="activeTab === 'all'">
                  <span class="tag video" v-if="lesson.videoUrl">Video</span>
                  <span class="tag notes" v-if="lesson.notesPath">Notes</span>
                </div>
              </div>
        
              <div class="lesson-status">
                <i class="bi bi-check-circle-fill" v-if="lesson.status === 'completed'"></i>
                <i class="bi bi-play-circle" v-else-if="lesson.status === 'in-progress'"></i>
              </div>
            </div>
          </div>
        </section>
        
        

    </main>

    <!-- Modern Sticky CTA -->
    <div class="cta-container" v-if="course.enrolled === 'No'">
      <router-link :to="'/cart?id='+course.id" class="modern-cta-btn" aria-label="Enroll now">
        <div class="cta-content">
          <span class="cta-price">₹{{ course?.cost }}</span>
          <span class="cta-text">Enroll Now</span>
        </div>
        <i class="bi bi-arrow-right"></i>
      </router-link>
    </div>
  </div>
</template>
 <script>
import axios from '@/plugins/axios'

export default {
  name: 'CourseDetails',

  data() {
    return {
      activeFilter: 'all',
      course: {
        id: 1,
        name: '',
        description: '',
        image: '',
        assignmentCount: 5,
        objectives: [],
        requirements: [],
        lessons: 0,
        enrolled: 'No',
        cost: 0,
        cat_name: '',
        user_details: []
      },
      lessons: [],
      activeTab: 'all',

      tabs: [
        { key: 'demo', label: 'Demo videos' },
        { key: 'all', label: 'All' },
        { key: 'videos', label: 'Videos' },
        { key: 'notes', label: 'Notes' },
      ],
    }
  },

  computed: {
    filteredLessons() {
      if (this.activeFilter === 'all') {
        return this.lessons
      }
      return this.lessons.filter(lesson => lesson.status === this.activeFilter)
    },
     filteredLessons() {
      switch (this.activeTab) {
        case 'demo':
          return this.lessons.filter(l => l.is_paid === 'No');

        case 'videos':
          return this.lessons.filter(l => l.videoUrl && l.videoUrl !== '');

        case 'notes':
          return this.lessons.filter(l => l.notesPath && l.notesPath !== '');

        default:
          return this.lessons; // All lessons
      }
    }
  },

  methods: {
    selectLesson(lesson) {

      // 
      if (this.course.enrolled === 'No' && lesson.is_paid === 'Yes') {
        this.$swal?.fire('This lesson is paid. Please enroll for this course.')
        return
      }else{
        // alert(lesson.full_payment+""+ this.user_details.balance);
              if(Number(lesson.full_payment)===1 && Number(this.user_details.balance)!==0)
              {
                this.$swal?.fire('Full payment needed for this.')
                  this.$router.push('/cart?id=' + this.course.id)
                return;
              }

          this.$router.push({
            path: '/lesson',
            query: { course: this.course.id, lesson: lesson.id }
          });
      }
    },

    enrollCourse() {
      this.course.enrolled = 'Yes'
      this.$swal?.fire('Successfully enrolled in the course!')
    },

    continueLearning() {
      const nextLesson = this.lessons.find(l => l.status === 'in-progress')
      if (nextLesson) {
        this.$router.push({
          path: '/lesson',
          query: { course: this.course.id, lesson: nextLesson.id }
        })
      } else {
        this.$swal?.fire('No lessons in progress. Start from the beginning!')
      }
    },

    goBack() {
      this.$router.push('/dashboard')
    },

    async getHomeBasic(courseid = 0) {
      if (!courseid) return
      try {
        const { data } = await axios.post('getCourceDetails', { courceid: courseid })
        if (data?.logged) {
          this.course = data.cource_details || this.course
          this.user_details = data.user_details
          this.lessons = data.lessons || []
        } else {
          // this.$router.push('/')
        }
      } catch (err) {
        this.$swal?.fire(err?.response?.data?.message || 'Something went wrong. Please try again.')
        console.error(err)
      }
    }
  },

  mounted() {
    const courseId = this.$route.query.id
    this.getHomeBasic(courseId)
  }
}
</script>



<style scoped>
.course-details-modern {
  min-height: 100vh;
  /*background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);*/
  position: relative;
}

.modern-header {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto;
  background: rgba(26, 26, 46, 0.95);
  padding: 10px;
}

.back-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.course-title {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.course-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  margin: 0;
}

.hero-section {
  position: relative;
  padding: 0.5rem;
  max-width: 1200px;
  margin: 0 auto;
  line-height: 10px;
}

.course-image-container {
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 0.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.course-hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);
}

.course-info-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 1.5rem;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.category-badge {
  display: inline-block;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 50px;
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 1rem;
}

.course-main-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 1rem;
  line-height: 1.3;
}

.price-container {
  display: flex;
  align-items: baseline;
  gap: 0.25rem;
  margin-bottom: 1rem;
}

.current-price {
  font-size: 2rem;
  font-weight: 800;
  color: #e74c3c;
}

.price-suffix {
  font-size: 1.2rem;
  color: #666;
}

.course-stats {
  display: flex;
  gap: 1rem;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #666;
  font-size: 0.9rem;
}

.stat-item i {
  color: #667eea;
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.5rem;
}

.content-card {
  background: rgba(255, 255, 255, 0.95); 
  border-radius: 20px;
  padding: 0.5rem !important;
  margin-bottom: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.section-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.section-title i {
  color: #667eea;
}

.course-description {
  color: #666;
  line-height: 1.6;
}

.lessons-grid {
  display: grid;
  gap: 0.5rem;
}

.lesson-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: -webkit-fill-available;
      max-width: -webkit-fill-available;
}

.lesson-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  background: white;
}

.lesson-card.lesson-locked {
  opacity: 0.6;
  cursor: not-allowed;
}

.lesson-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea, #764ba2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
}

.lesson-card.lesson-locked .lesson-icon {
  background: #bbb;
}

.lesson-content {
  flex: 1;
}

.lesson-title {
  font-size: 0.7rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 0.25rem;
}

.lesson-meta {
  display: flex;
  gap: 1rem;
}

.lesson-duration {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: #666;
  font-size:0.55rem;
}

.lesson-status i {
  font-size: 1.2rem;
  color: #27ae60;
}

.cta-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.modern-cta-btn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
 background: linear-gradient(135deg, #000001 0%, #764ba2 100%);
  color: white;
  text-decoration: none;
  padding: 1rem 1.5rem;
  border-radius: 50px;
  font-weight: 600;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}

.modern-cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 35px rgba(102, 126, 234, 0.5);
  color: white;
}

.cta-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.cta-price {
  font-size: 1.2rem;
  font-weight: 800;
}

.cta-text {
  font-size: 0.9rem;
  opacity: 0.9;
}

@media (min-width: 768px) {
  .hero-section {
    padding: 3rem 2rem;
  }
  
  .course-image-container {
    height: 250px;
  }
  
  .course-main-title {
    font-size: 2rem;
  }
  
  .current-price {
    font-size: 2.5rem;
  }
  
  .main-content {
    padding: 0 2rem 6rem;
  }
  
  .lessons-grid {
    grid-template-columns: 1fr;
  }
  
  .cta-container {
    padding: 1.5rem 2rem;
  }
}

.tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
}

.tabs button {
  padding: 8px 15px;
  border: 1px solid #ccc;
  background: #f5f5f5;
  cursor: pointer;
  border-radius: 4px;
}

.tabs button.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}
.lesson-tags {
  margin-top: 6px;
  display: flex;
  gap: 6px;
}

.tag {
  font-size: 12px;
  padding: 3px 8px;
  border-radius: 4px;
  background: #e5e5e5;
}

.tag.video {
  background: #d0ebff;
  color: #0366d6;
}

.tag.notes {
  background: #ffe8a1;
  color: #8a6d1c;
}
</style>